import React from 'react';
import {isIOS, isTablet} from 'react-device-detect';
import Tooltip from '../../../../../Shared/Tooltip/Tooltip';
import InfoLine from './InfoLine';
import './Tooltip.scss';

const AbroadTooltip = ({tooltipId = '', tooltipText = '', placement = '', isFromAbroadDataUsage = false, onclick = null}) => {
  let tooltipClass = `AbroadTooltip ${tooltipId}`;
  if (isFromAbroadDataUsage) {
    tooltipClass += ' AbroadDataUsageTooltip';
  } else {
    if (isIOS) {
      tooltipClass += ' iosAbroadTooltipText';
    }
  }
  return (
    <>
      <span className={isIOS ? 'tooltipSpaniPhoneMode' : ''} id={tooltipId} onClick={onclick}>
        <InfoLine />
      </span>
      <Tooltip
        placement={`${placement ? (isIOS && !isTablet ? 'top' : placement) : 'top'}`}
        target={tooltipId}
        text={tooltipText}
        className={tooltipClass}
      />
    </>
  );
};

export default AbroadTooltip;
